import { Drawer } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { MessageReadingPane } from "./MessageReadingPane.tsx"

export { deliveryTimeline, isHeld } from "./MessageReadingPane.tsx"

/** The reading pane as a drawer, for screens outside the Messages tab (record timelines, campaign reports). */
const MessageDetailDrawer = ({
  messageId,
  onClose
}: {
  messageId: string | null
  onClose: () => void
}) => {
  const { t } = useTranslation()
  return (
    <Drawer
      open={!!messageId}
      onClose={onClose}
      width={720}
      destroyOnHidden
      title={t("communication.messages.detail.title")}
    >
      <div className="[&_:is(h1,h2,h3)]:text-left">
        {messageId && <MessageReadingPane messageId={messageId} />}
      </div>
    </Drawer>
  )
}

export default MessageDetailDrawer
